import React from 'react';
import PropTypes from 'prop-types';
import { SmallDialog } from '../../components/widgets';
import MonitorComposer from './MonitorComposer';
import css from './MonitorEditDialog.css';

const noop = () => {};

// An existing monitor is edited in a dialog so the board underneath keeps its place; a new
// monitor is still composed inline. `paper` is doubled in the stylesheet to outrank the
// single-class JSS rule SmallDialog puts on the same node.
const MonitorEditDialog = ({ open, saving = false, onCancel, ...composerProps }) => (
    <SmallDialog
        open={open}
        showX={false}
        onClose={saving ? noop : onCancel}
        onEscapePress={saving ? noop : onCancel}
        disableBackdropClick={saving}
        classes={{ paperScrollBody: css.paper }}
    >
        <MonitorComposer {...composerProps} saving={saving} onCancel={onCancel} inDialog />
    </SmallDialog>
);

MonitorEditDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    saving: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
};

export default MonitorEditDialog;
